<div class="modal-header">
    <div class="d-flex align-items-center">
        <img
            src="../../../../assets/images/SuperOffice_logo.svg"
            class="pointer"
            style="height: 30px; vertical-align: middle; margin-right: 8px" />
        <h4 class="modal-title pull-left" translate>Save email to SuperOffice</h4>
    </div>
    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="decline()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    <form #replyForm="ngForm" [ngClass]="{ 'form-submitted': isSubmitted }">
        <div class="form-group flex-fill">
            <label for="emailSubject" translate>Subject</label>
            <input
                type="text"
                class="form-control"
                id="emailSubject"
                placeholder="{{ 'Email subject' | translate }}"
                [(ngModel)]="emailModel.subject"
                name="emailSubject"
                autocomplete="off"
                required />
        </div>

        <div class="form-group flex-fill">
            <label for="companyName" (click)="companyNameNgSelect.open()" translate>Company</label>
            <ng-select
                #companyNameSelect
                bindLabel="name"
                dropdownPosition="bottom"
                name="companyName"
                id="companyName"
                class="select-control z-index-1055"
                appendTo="body"
                [(ngModel)]="emailModel.company"
                [items]="companies"
                [placeholder]="'Company name' | translate"
                [loading]="loadingCompanies"
                [notFoundText]="
                    searchCompanyText && searchCompanyText.length >= minSearchLength
                        ? ('No companies found' | translate)
                        : ('start typing to search company' | translate)
                "
                [loadingText]="'Loading...'"
                (search)="onSearch($event, 'company')"
                (change)="onSelect($event, 'company')"
                (clear)="clearList('company')"
                required>
            </ng-select>
            <div class="form-text text-light">
                {{ minSearchLength + ' ' + ('characters required' | translate) }}
            </div>
        </div>

        <div class="form-group flex-fill">
            <label for="person" translate (click)="personNgSelect.open()">Person</label>
            <ng-select
                #personSelect
                name="person"
                id="person"
                dropdownPosition="bottom"
                bindLabel="fullName"
                class="select-control z-index-1055"
                appendTo="body"
                [(ngModel)]="emailModel.person"
                [items]="persons"
                [placeholder]="'Person name' | translate"
                [loading]="loadingPeople"
                [notFoundText]="
                    searchPersonText && searchPersonText.length >= minSearchLength
                        ? ('No persons found' | translate)
                        : ('start typing to search person' | translate)
                "
                [loadingText]="'Loading...'"
                [searchFn]="searchStub"
                (search)="onSearch($event, 'person')"
                (change)="onSelect($event, 'person')"
                (clear)="clearList('person')">
                <ng-template ng-option-tmp let-item="item">
                    {{ item.fullName }} <br />
                    <small ng-if="item.emails && item.emails.length">
                        {{ item.emails[0] }}
                    </small>
                </ng-template>
            </ng-select>
            <div class="form-text text-light">
                {{ minSearchLength + ' ' + ('characters required' | translate) }}
            </div>
        </div>

        <div class="form-group flex-fill">
            <label for="project" (click)="projectNgSelect.open()" translate>Project</label>
            <ng-select
                #projectSelect
                name="project"
                id="project"
                dropdownPosition="bottom"
                bindLabel="name"
                class="select-control z-index-1055"
                appendTo="body"
                [(ngModel)]="emailModel.project"
                [items]="projects"
                [placeholder]="'Project name' | translate"
                [loading]="loadingProjects"
                [notFoundText]="
                    searchProjectText && searchProjectText.length >= minSearchLength
                        ? ('No projects found' | translate)
                        : ('start typing to search project' | translate)
                "
                [loadingText]="'Loading...'"
                (search)="onSearch($event, 'project')"
                (clear)="clearList('project')">
            </ng-select>
            <div class="form-text text-light">
                {{ minSearchLength + ' ' + ('characters required' | translate) }}
            </div>
        </div>

        <div class="d-flex flex-row align-items-end">
            <div class="form-group me-1" style="width: 33%">
                <label for="date" translate>Date</label>
                <select class="form-control" [(ngModel)]="emailModel.date" id="date" name="date" disabled>
                    <option [value]="emailModel.date">
                        {{ emailModel.date | date: 'dd/MM/yyyy' }}
                    </option>
                </select>
            </div>

            <div class="form-group me-1 ms-1" style="width: 33%">
                <label for="type" translate>Type</label>
                <select class="form-control" [(ngModel)]="emailModel.type" id="type" name="type" disabled>
                    <option value="email" translate>Email</option>
                </select>
            </div>

            <div class="d-flex form-group flex-column ms-1" style="width: 33%">
                <label for="availableFor" translate>Available for...</label>
                <select
                    class="form-control"
                    [(ngModel)]="emailModel.availableFor"
                    id="availableFor"
                    name="availableFor"
                    disabled>
                    <option value="all" translate>All</option>
                </select>
            </div>
        </div>

        <div class="d-flex flex-row align-items-end">
            <div class="form-group me-3">
                <label class="checkbox__label checkbox__label--size-small checkbox__disabled" for="hasAttachments">
                    <span translate>Include attachments</span>
                    <input
                        type="checkbox"
                        id="hasAttachments"
                        name="hasAttachments"
                        disabled
                        [(ngModel)]="emailModel.hasAttachments" />
                    <span class="checkbox__checkmark"></span>
                </label>
            </div>

            <div class="form-group">
                <label class="checkbox__label checkbox__label--size-small checkbox__disabled" for="isCompleted">
                    <span translate>Completed</span>
                    <input
                        type="checkbox"
                        id="isCompleted"
                        name="isCompleted"
                        disabled
                        [(ngModel)]="emailModel.isCompleted" />
                    <span class="checkbox__checkmark"></span>
                </label>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button type="submit" class="btn btn-primary" (click)="save()" translate>Save email to CRM</button>
</div>
